// 法务处理
import request from '@/router/axios';

// 列表
export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/page',
    method: 'post',
    data: {
      ...params,
      current,
      size,
    },
  });
};
// 诉讼
export const getLawsuit = row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/lawsuit',
    method: 'post',
    data: row,
  });
};

// 法务记录
export const getLegalRecord = row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/legalRecord',
    method: 'post',
    data: row,
  });
};

// 客户还租
export const getLegalAffairs = row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/legalAffairs-repayment',
    method: 'post',
    data: row,
  });
};
// 转刑事
export const getToCriminal = row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/toCriminal',
    method: 'post',
    data: row,
  });
};
// 行动协助
export const getActiveAssistance = row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/activeAssistance',
    method: 'post',
    data: row,
  });
};

// 委托第三方
export const getEntrustOther = row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/entrustOther',
    method: 'post',
    data: row,
  });
};

// 作废
export const getCancelLegalAffairs= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/cancelLegalAffairs',
    method: 'post',
    data: row,
  });
};
// 诉讼中（一审）

// 诉讼立案
export const submitLawsuitCase= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/lawsuitCase',
    method: 'post',
    data: row,
  });
};

// 一审庭前调解
export const submitConciliation= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/conciliation',
    method: 'post',
    data: row,
  });
};

// 一审开庭
export const submitOneOpenCourt= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/oneOpenCourt',
    method: 'post',
    data: row,
  });
};

// 一审判决
export const submitSentence= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/sentence',
    method: 'post',
    data: row,
  });
};

// 上诉
export const submitAppeal= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/appeal',
    method: 'post',
    data: row,
  });
};

// 执行
export const submitExecuteEntry= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/executeEntry',
    method: 'post',
    data: row,
  });
};

// 调解收款 & 执行收款  & 刑案收款 & 法务谈判
export const submitLoanLegalAffairsRepayment= row => {
  return request({
    url: '/api/blade-loanLegalAffairsRepayment/loanLegalAffairsRepayment/submit',
    method: 'post',
    data: row,
  });
};

// 撤诉
export const submitNolleProsequi= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/nolleProsequi',
    method: 'post',
    data: row,
  });
};

// 诉讼详情
export const submitLegalAffairsDetails= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/legalAffairsDetails',
    method: 'post',
    data: row,
  });
};

// 诉讼中（二审）
// 二审庭前调解
export const submitTwoConciliation= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/twoConciliation',
    method: 'post',
    data: row,
  });
};
// 二审开庭
export const submitTwoOpenCourt= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/twoOpenCourt',
    method: 'post',
    data: row,
  });
};
// 二审判决
export const submitTwoSentence= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/twoSentence',
    method: 'post',
    data: row,
  });
};

// 执行阶段
// 跟进执行
export const submitFollowImplementation= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/followImplementation',
    method: 'post',
    data: row,
  });
}
// 完成执行
export const submitFulfillImplementation= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/fulfillImplementation',
    method: 'post',
    data: row,
  });
}

// 不良资产
// 三方拖车
export const submitOtherTrailer= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/otherTrailer',
    method: 'post',
    data: row,
  });
}
// 法务结清
export const submitLegalSettle= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/legalSettle',
    method: 'post',
    data: row,
  });
}
// 转卖车
export const submitOptionaLegalAffairsCar= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/optional_legal_affairs_car',
    method: 'post',
    data: row,
  });
}

// 刑事立案
export const submitCriminalRegister= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/criminalRegister',
    method: 'post',
    data: row,
  });
}
// 刑事结清
export const submitCriminalSettle= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/criminalSettle',
    method: 'post',
    data: row,
  });
}

// 法务-查看客户的租金和剩余金额
export const getAmountByLoanPostId= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/getAmountByLoanPostId',
    method: 'post',
    data: row,
  });
}

// 法务-查看代理商下客户
export const getLoanPostByDeptId= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/getLoanPostByDeptId',
    method: 'post',
    data: row,
  });
}

// 法务-自选诉讼
export const getOptionalAction= row => {
  return request({
    url: '/api/blade-loanLegalAffairs/loanLegalAffairs/optional_action',
    method: 'post',
    data: row,
  });
}

// 获取法务 不良资产 转卖车中回显车库位置
export const getVehicleLocation = (loanPostId) => {
    return request({
        url: '/api/blade-loanLegalAffairs/loanLegalAffairs/vehicle_location/' + loanPostId,
        method: 'get',
    })
}
